import { css } from '@emotion/css'
export const wrap = css``
